<!--
 * @Author: w9013327 v-maijiahua@oppo.com
 * @Date: 2022-11-01 18:26:49
 * @LastEditors: w9013327 v-maijiahua@oppo.com
 * @LastEditTime: 2023-11-29 15:19:59
 * @FilePath: \sns-user-frontend\src\views\thread\web\index.vue
 * @Description: 帖子详情页
-->
<template>

  <div class="thread">
    <div class="thread-l" ref="threadL" v-if="threadInfo">
      <!-- 帖子正文 -->
      <Thread v-model="threadInfo" />
      <!-- 评论区 -->
      <AllComment v-model="threadInfo" />
    </div>

    <!-- 帖子的特殊情况 -->
    <SpecialDetail :specialData="specialData" v-else />

    <div class="thread-r" ref="threadR">
      <!-- 作者信息 -->
      <Author v-model="authorInfo" v-if="authorInfo" />
      <!-- 圈内推荐卡片 -->
      <template v-if="relatedInfo">
        <p class="related-title">{{ $t('mightBeLike')}}</p>
        <RecommendedCard v-for="(related, index) in relatedInfo" :key="index" :recommendedData="related"
          :showAction="true" />
      </template>
    </div>
  </div>
  <ActionBar @updateBestPick="updateBestPick" v-model="threadInfo" v-if="threadInfo" />
</template>

<script setup>

  import { useUserStore } from '@/stores/user'

  import http from '@/service'
  import { richText4View } from '@/utils/formatRichText'
  import { compare } from '@/utils'

  import SpecialDetail from './components/specialDetail'
  import Thread from './components/thread'
  import AllComment from './components/allComment'
  import Author from './components/author'
  import RecommendedCard from '@/components/web/recommendedCard'
  import ActionBar from '@/components/web/actionBar'
  import { storeToRefs } from 'pinia'
  import XssFilter from '@/utils/xssFilter'


  const route = useRoute()
  const userStore = useUserStore()
  const { uid } = storeToRefs(userStore)
  const { proxy } = getCurrentInstance()

  let threadInfo = ref(null)

  let authorInfo = ref(null)

  let relatedInfo = ref(null)

  const threadL = ref(null)
  const threadR = ref(null)
  const specialData = ref({})

  const getRelatedThread = (circleBasicInfo) => {
    if (relatedInfo.value?.length) return
    // 圈子推荐帖
    if (!circleBasicInfo || !circleBasicInfo.id) return
    http.getRelatedList({
      circleId: circleBasicInfo.id,
      tid: route.params.id
    }).then(res => {
      if (res.code === 200 && res.data && res.data.length) {
        relatedInfo.value = res.data.map(r => {
          const { id: threadId, threadStat, publishUserInfo, attachmentList, subject, content, praised } = r
          const { avatar: authorAvatar, iconLink: authorIcon, nickname: authorName, uid: authorId } = publishUserInfo
          let image = ''
          if (attachmentList && attachmentList.length) {
            image = attachmentList[0].type === 1 ? attachmentList[0].url : attachmentList[0].snapshot
          }
          const title = subject ? subject : content.substr(0, 150)
          return {
            authorAvatar,
            authorIcon,
            authorName,
            authorId,
            threadId,
            threadStat,
            praised,
            image,
            title
          }
        })
        if (relatedInfo.value.length) {
          nextTick(() => {
            threadL.value.style.minHeight = `${threadR.value.offsetHeight}px`
          })
        }
      } else {

      }
    })
  }

  const queryThread = async () => {
    // 获取帖子详情
    let { code, data, msg } = await http.getThreadInfo({
      id: route.params.id
    })

    if (code !== 200) {
      specialData.value = data || { description: msg }
      return
    }

    setBrowserTabTitle(data)

    if (data.hideContent) {
      data.content = `${data.content}${data.hideContent || ''}`
    }
    // 富文本格式化
    data.content = richText4View(data)
    // 投票类型
    if (data.type === 4) {
      // 获取投票选项中的图片地址
      data.options = data.options.map((i, index) => {
        // i.attachments = i.attachments ? data.attachments.find(a => a.id === i.attachments).url : ''
        if (i.attachments) {
          data.attachments.forEach(a => {
            if (a.id === i.attachments) {
              i.attachments = a.url
              let { width, height } = a
              height = (height / width) * 280
              i.height = `${height}px`
            }
          })
        }
        return { ...i }
      })

      // 图片按后端sort字段排序
      data.options.sort(compare('sort'))
    }
    threadInfo.value = { ...data }  // 帖子数据
    authorInfo.value = { ...data.publishUserInfo }   // 作者数据
    const { circleBasicInfo } = data || {}
    getRelatedThread(circleBasicInfo)
    http.onView({
      id: data.id
    })
  }

  const setBrowserTabTitle = ({ subject, content }) => {
    let tabTitle = ''
    if (subject) {
      tabTitle = subject.substring(0, 50)
    } else {
      const vituralDom = document.createElement('div')
      vituralDom.innerHTML = XssFilter(content)
      tabTitle = vituralDom.innerText.substring(0, 50)
    }
    if (tabTitle) {
      document.title = tabTitle
    }
  }

  const updateBestPick = (val) => {
    threadInfo.value.stamp = val
  }
  async function initPage() {
    await queryThread()
    proxy.$ga('thread_view', {
      "screen_name": route.name,
      "thread_category": threadInfo.value?.type,
      "thread_id": route.params.id,
      "circle_id": threadInfo.value?.circleBasicInfo?.id,
      "author_id": threadInfo.value?.publishUserInfo?.uid
    })
  }

  watch(route, (val) => {
    const { name, params } = val || {}
    authorInfo.value = null
    threadInfo.value = null
    relatedInfo.value = null
    specialData.value = {}
    if (name === 'thread') {
      const { autoLogin } = val.query || {}
      if (!uid.value && autoLogin) {
        userStore.onLogin({
          redirectUrl: `${location.origin}${location.pathname}`
        })
      }
      initPage()
    }
  }, {
    immediate: true,
    deep: true
  })

</script>

<style lang="postcss" scoped>
  .thread {
    display: flex;
    flex-flow: row nowrap;
    align-items: flex-start;
    justify-content: flex-start;
    width: 1200px;
    margin: 0 auto;

    &-l {
      position: relative;
      width: 792px;
      min-height: calc(100vh - 72px - 144px);
      padding-right: 47px;
      border-right: 1px solid var(--line);
      padding-bottom: 80px;
    }

    &-r {
      padding: 100px 0 0 48px;

      .related-title {
        display: inline-block;
        font-size: 24px;
        margin: 96px 0 24px 0;
      }

      .recommended {
        width: 312px;
        border: 1px solid var(--line);
        border-radius: 16px;
        margin-bottom: 24px;
        margin-right: 0;

        :deep(&-image) {
          height: 175px;

          .ob-image {
            border-radius: 16px 16px 0 0;
          }
        }
      }
    }
  }

  .deleted {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100vw;
    height: calc(100vh - 278px);
    font-size: 24px;
    color: var(--text-secondary);
  }

  :deep(.following) {
    background: var(--background-light);

    span {
      color: var(--text-primary);
      font-family: "orbit-M";
      font-size: 14px;
    }
  }
</style>